export default class IMTimeMode {
  delayfuns = [];

  repeatfuns = [];
  delay(fuc, ms) {
    let f = setTimeout(fuc, ms);
    this.delayfuns.push(f);
  }

  repeat(fuc, ms, isExcuteFirst) {
    let f = setInterval(fuc, ms);
    this.repeatfuns.push(f);
    isExcuteFirst && fuc();
  }

  clearFunc() {
    for (let i = 0; i < this.delayfuns.length; i++) {
      clearTimeout(this.delayfuns[i]);
    }
    for (let i = 0; i < this.repeatfuns.length; i++) {
      clearTimeout(this.repeatfuns[i]);
    }
    this.delayfuns = [];
    this.repeatfuns = [];
  }

  clearRepeat() {
    for (let i = 0; i < this.repeatfuns.length; i++) {
      clearTimeout(this.repeatfuns[i]);
    }
    this.repeatfuns = [];
  }
}
